import { Box, Typography } from '@mui/material';

import { FindingsList, type Finding } from './FindingsList';
import { parseFindings } from '../utils/parseFindings';
import { splitFindingText } from '../utils/splitFindingText';
import { COLORS } from '../../IndividualPlan/tokens';
import { findSection, type PeContent, type PeReport } from '../types';

export interface TopFindingsProps {
  report: PeReport;
  content: PeContent;
}

export function TopFindings({ content }: TopFindingsProps) {
  const section = findSection(content, 'top_findings');
  if (!section) {
    return null;
  }

  const findings: Finding[] = parseFindings(section.text).map((finding) => {
    const { headline, supporting } = splitFindingText(finding.text);
    return { text: headline, subline: supporting };
  });

  if (findings.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography
        component="p"
        sx={{
          m: 0,
          fontSize: 16,
          fontWeight: 700,
          lineHeight: '24px',
          color: COLORS.muted,
          textTransform: 'capitalize',
        }}
      >
        Top Findings
      </Typography>
      <FindingsList findings={findings} />
    </Box>
  );
}
